var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("img", {
      attrs: { src: _vm.platformLogos.tradique, width: "100", height: "100" }
    }),
    _vm._v(" "),
    _c("h1", { staticClass: "title my-5" }, [_vm._v("Log into Tradique")]),
    _vm._v(" "),
    _c(
      "form",
      {
        ref: "formRef",
        staticClass: "login-form-container",
        attrs: { method: "POST", action: _vm.urls.login }
      },
      [
        _c("field-input", {
          ref: "emailRef",
          staticClass: "mb-4",
          attrs: {
            id: "login_input",
            type: "email",
            name: "login",
            label: "Email",
            "server-error": _vm.serverError.login,
            isEN: "",
            rules: [
              _vm.vRules.required("Please enter your Email address."),
              _vm.vRules.email("Email is not valid.")
            ]
          },
          model: {
            value: _vm.email,
            callback: function($$v) {
              _vm.email = $$v
            },
            expression: "email"
          }
        }),
        _vm._v(" "),
        _c("field-input", {
          ref: "passwordRef",
          staticClass: "mb-4",
          attrs: {
            id: "password_input",
            type: "password",
            name: "password",
            label: "Password",
            "input-class": "ltr",
            isEN: "",
            "server-error": _vm.serverError.password,
            rules: [_vm.vRules.required("Please enter your password.")]
          },
          model: {
            value: _vm.password,
            callback: function($$v) {
              _vm.password = $$v
            },
            expression: "password"
          }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "hidden", name: "csrfmiddlewaretoken" },
          domProps: { value: _vm.csrfToken }
        }),
        _vm._v(" "),
        _vm.redirectFieldValue
          ? _c("input", {
              attrs: { type: "hidden", name: _vm.redirectFieldName },
              domProps: { value: _vm.redirectFieldValue }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.serverError.nonFieldErrors
          ? _c("div", { staticClass: "mt-0 error-text text-center mb-4" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.serverError.nonFieldErrors) + "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn tradique-primary-btn w-100",
            attrs: { type: "submit", disabled: _vm.isLoading }
          },
          [_vm._v("\n      Sign In\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }